/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../../../index';

/**
 * @example
 *     {
 *         message: "message",
 *         type: "DATA_DUMP"
 *     }
 */
export interface SupportRequestCreateRequest {
    /** The message of the support request. */
    message: string;
    /** The type of the support request. */
    type: Truvity.SupportRequestCreateRequestType;
}
